import { debounce } from "../../utils/utils";

const updateVideo = (element) => {
    let mobileSrc = element.getAttribute('data-srcMobile');
    let desktopSrc = element.getAttribute('data-srcDesktop');
    const screenwidth = window.innerWidth;

    if (screenwidth <= 425 && mobileSrc !== "") {
        element.setAttribute('src', mobileSrc);
    } else {
        element.setAttribute('src', desktopSrc);
    }
};

const updateAllVideos = () => {
    document.querySelectorAll(".bg-video-responsive").forEach((element) => {
        updateVideo(element);
    });
};

window.addEventListener('DOMContentLoaded', () => {
    updateAllVideos();
});

window.addEventListener('orientationchange', debounce(updateAllVideos, 300));